













import {
  defineComponent,
  useContext
} from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import { useUiHelpers } from '@wemade-vsf/composables';
export default defineComponent({
    props: ['data'],
    components: {
        SfLink
    },
    setup() {
        const { localePath } = useContext();
        const { getCatLink } = useUiHelpers();

        const getCategoryLink = (category) => {
            return decodeURIComponent(localePath(getCatLink(category)))
        }

        return {
            getCategoryLink
        }
    }
})
